// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*html, body
  height: 100%
  
body
  color: #fff
  background-color: #1d1e22
  font-family: Abel, Arial, Helvetica Neue
  padding: 40px
  
button, input
  font-family: inherit
  
h1
  font-size: 2em
  display: inline-block

h2
  font-size: 1.2em
  color: rgba(255, 255, 255, 0.6)
  font-style: italic
  margin-top: 0.5em

a
  color: white
p
  margin-top: 1em
  text-align: center
  color: #aaa
*/
.image-uploader {
  /* width: 420px; */
  margin: 10px 0;
}

.image-uploader-container {
  /* width: 420px; */
  height: 420px;
  margin: 20px auto;
  background-color: whitesmoke;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  background-image: url(http://svgshare.com/i/3R5.svg);
  display: flex;
  position: relative;
}

.image-uploader-container::before {
  background-color: rgba(0, 0, 0, 0.4);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  content: "";
  display: block;
}
.image-upload-button-container {
  position: relative;
  display: inline-block;
}
.image-upload-button {
  position: absolute;
  left: 0;
  width: 100%;
  top: 0;
  bottom: 0;
  opacity: 0;
  cursor: pointer;
}
.image-upload-preview {
  height: 100%;
  background-size: cover;
  /* background-color: black;*/
  background-position: center center;
  background-repeat: no-repeat;
  position: relative;
  flex: 1 1;
}
.image-upload-button-view-full {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
}
.image-thumbnails {
  display: flex;
  flex-flow: row wrap;
  /* margin: 0 -5px;*/
}
.image-thumbnail {
  height: 60px;
  width: 60px;
  background-size: cover;
  background-position: center center;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5px 5px;
  cursor: pointer;
  background-color: #222c2f;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.image-thumbnail-selected {
  box-shadow: 0 0 0px 2px #4d90fe;
  transform: scale(1.1, 1.1);
}

.image-preview-index {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  border-radius: 8px;
  padding: 4px 6px;
  font-size: 10px;
  line-height: 9px;
  z-index: 10;
}

.image-preview-overlay {
  position: absolute;
  top: 60%;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    to top,
    black 0%,
    rgba(0, 0, 0, 0.5) 40%,
    rgba(0, 0, 0, 0)
  );
  opacity: 0.6;
  transition: opacity 0.2s ease-in-out;
}

.image-upload-preview:hover .image-preview-overlay {
  opacity: 1;
}

.image-action-buttons {
  padding: 10px;
  width: 150px;
  background-color: #222c2f;
  z-index: 1;
}

.image-action-button {
  height: 30px;
  width: 100%;
  text-align: center;
  background-color: transparent;
  color: white;
  font-size: 14px;
  border: none;
  outline: none;
  cursor: pointer;
  transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out;
}

.image-action-button:hover {
  color: #36b6f2;
}

.image-navigation-buttons {
  position: absolute;
  top: 40%;
  bottom: 40%;
  left: 0;
  right: 0;
  z-index: 10;
  display: flex;
  justify-content: space-between;
}

.image-navigation-button {
  width: 30px;
  height: 30px;
  margin: auto 10px;
  border-radius: 50%;
  line-height: 28px;
  background-color: rgba(255, 255, 255, 0.4);
  color: rgb(233, 226, 226);
  outline: none;
  border: none;
  opacity: 0.5;
  cursor: pointer;
  transform: scale(1);
  transition: opacity 0.2s ease-in-out, padding 0.2s ease-in-out;
  backdrop-filter: blur(5px);
}

.image-upload-preview:hover .image-navigation-button {
  opacity: 1;
}
.image-navigation-button:first-child {
  padding-right: 8px;
}
.image-navigation-button:first-child:hover {
  padding-right: 12px;
}
.image-navigation-button:last-child {
  padding-left: 8px;
}

.image-navigation-button:last-child:hover {
  padding-left: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/controls/uploader/imageUploader.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA4BC;AACD;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,4BAA4B;EAC5B,0CAA0C;EAC1C,oDAAoD;EACpD,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,MAAM;EACN,SAAS;EACT,UAAU;EACV,eAAe;AACjB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,4BAA4B;EAC5B,kCAAkC;EAClC,4BAA4B;EAC5B,kBAAkB;EAClB,SAAO;AACT;AACA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,kCAAkC;EAClC,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,0CAA0C;EAC1C,mEAAmE;AACrE;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;;GAKC;EACD,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,eAAe;EACf,qEAAqE;AACvE;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,0CAA0C;EAC1C,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,8DAA8D;EAC9D,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["/*html, body\n  height: 100%\n  \nbody\n  color: #fff\n  background-color: #1d1e22\n  font-family: Abel, Arial, Helvetica Neue\n  padding: 40px\n  \nbutton, input\n  font-family: inherit\n  \nh1\n  font-size: 2em\n  display: inline-block\n\nh2\n  font-size: 1.2em\n  color: rgba(255, 255, 255, 0.6)\n  font-style: italic\n  margin-top: 0.5em\n\na\n  color: white\np\n  margin-top: 1em\n  text-align: center\n  color: #aaa\n*/\n.image-uploader {\n  /* width: 420px; */\n  margin: 10px 0;\n}\n\n.image-uploader-container {\n  /* width: 420px; */\n  height: 420px;\n  margin: 20px auto;\n  background-color: whitesmoke;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);\n  background-image: url(http://svgshare.com/i/3R5.svg);\n  display: flex;\n  position: relative;\n}\n\n.image-uploader-container::before {\n  background-color: rgba(0, 0, 0, 0.4);\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  content: \"\";\n  display: block;\n}\n.image-upload-button-container {\n  position: relative;\n  display: inline-block;\n}\n.image-upload-button {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  top: 0;\n  bottom: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n.image-upload-preview {\n  height: 100%;\n  background-size: cover;\n  /* background-color: black;*/\n  background-position: center center;\n  background-repeat: no-repeat;\n  position: relative;\n  flex: 1;\n}\n.image-upload-button-view-full {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: auto;\n}\n.image-thumbnails {\n  display: flex;\n  flex-flow: row wrap;\n  /* margin: 0 -5px;*/\n}\n.image-thumbnail {\n  height: 60px;\n  width: 60px;\n  background-size: cover;\n  background-position: center center;\n  background-color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 5px 5px;\n  cursor: pointer;\n  background-color: #222c2f;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);\n  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n}\n\n.image-thumbnail-selected {\n  box-shadow: 0 0 0px 2px #4d90fe;\n  transform: scale(1.1, 1.1);\n}\n\n.image-preview-index {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background-color: rgba(0, 0, 0, 0.7);\n  color: white;\n  border-radius: 8px;\n  padding: 4px 6px;\n  font-size: 10px;\n  line-height: 9px;\n  z-index: 10;\n}\n\n.image-preview-overlay {\n  position: absolute;\n  top: 60%;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(\n    to top,\n    black 0%,\n    rgba(0, 0, 0, 0.5) 40%,\n    rgba(0, 0, 0, 0)\n  );\n  opacity: 0.6;\n  transition: opacity 0.2s ease-in-out;\n}\n\n.image-upload-preview:hover .image-preview-overlay {\n  opacity: 1;\n}\n\n.image-action-buttons {\n  padding: 10px;\n  width: 150px;\n  background-color: #222c2f;\n  z-index: 1;\n}\n\n.image-action-button {\n  height: 30px;\n  width: 100%;\n  text-align: center;\n  background-color: transparent;\n  color: white;\n  font-size: 14px;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out;\n}\n\n.image-action-button:hover {\n  color: #36b6f2;\n}\n\n.image-navigation-buttons {\n  position: absolute;\n  top: 40%;\n  bottom: 40%;\n  left: 0;\n  right: 0;\n  z-index: 10;\n  display: flex;\n  justify-content: space-between;\n}\n\n.image-navigation-button {\n  width: 30px;\n  height: 30px;\n  margin: auto 10px;\n  border-radius: 50%;\n  line-height: 28px;\n  background-color: rgba(255, 255, 255, 0.4);\n  color: rgb(233, 226, 226);\n  outline: none;\n  border: none;\n  opacity: 0.5;\n  cursor: pointer;\n  transform: scale(1);\n  transition: opacity 0.2s ease-in-out, padding 0.2s ease-in-out;\n  backdrop-filter: blur(5px);\n}\n\n.image-upload-preview:hover .image-navigation-button {\n  opacity: 1;\n}\n.image-navigation-button:first-child {\n  padding-right: 8px;\n}\n.image-navigation-button:first-child:hover {\n  padding-right: 12px;\n}\n.image-navigation-button:last-child {\n  padding-left: 8px;\n}\n\n.image-navigation-button:last-child:hover {\n  padding-left: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
